import { ComponentProps, forwardRef } from "react";
import { PaperclipIcon } from "@phosphor-icons/react";
import { Button } from "@libs/zapi-ui/ds/components/button";

type TChatAttachButtonProps = Omit<ComponentProps<typeof Button>, "children" | "variant" | "size" | "shape"> & {
  label: string;
};

export const ChatAttachButton = forwardRef<HTMLButtonElement, TChatAttachButtonProps>(function ChatAttachButton(
  { label, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      size="icon-sm"
      shape="pill"
      aria-label={label}
      title={label}
      {...props}
    >
      <PaperclipIcon />
    </Button>
  );
});
